// ============================================
// components/fields/DocumentTypeField.js

const DocumentTypeField = ({ field, value, error, onChange }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {field.title}
        {field.required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      >
        <option value="">Select document type</option>
        <option value="utility_bill">Utility Bill</option>
        <option value="bank_statement">Bank Statement</option>
        <option value="lease_agreement">Lease Agreement</option>
        <option value="government_mail">Government Mail</option>
        <option value="other">Other</option>
      </select>
      {error && (
        <p className="text-sm text-red-600 mt-1">{error}</p>
      )}
    </div>
  );
};

export default DocumentTypeField;